import {LearningData} from "common/datapersistence/LearningData";
import {CourseEvents} from "course/CourseEvents";
import {Assert} from "common/Assert";
import {Event} from "common/Event";

export function ScormUIData( dataAdapter ) {

    Assert.checkArgument( dataAdapter );
    Assert.checkArgumentType( dataAdapter.getUsername, "function" );
    Assert.checkArgumentType( dataAdapter.getScore, "function" );
    Assert.checkArgumentType( dataAdapter.getStatus, "function" );
    Assert.checkArgumentType( dataAdapter.getLocation, "function" );
    Assert.checkArgumentType( dataAdapter.getStorageType, "function" );

    const learningData = new LearningData();

    // revealing public api
    return {

        // public api for config

        /**
         * Gets the storage method for the course.
         *
         * @returns {String} "scorm2004" for a scorm 1.3 course, otherwise "jsapi"
         */
        getStorageMethod : dataAdapter.getStorageType,

        /**
         * Gets current course score.
         * @param {String} scoId
         * @returns {Number} score
         */
        getScore: ( scoId ) => {
            let score = learningData.getScore(scoId);
            return score > 100 ? 100 : score;
        },

        /**
         * Gets current course (lesson) status.
         * @param {String} scoId
         * @returns {String} lesson status or "unknown"
         */
        getLessonStatus: learningData.getLessonStatus,

        /**
         * Checks the lessons status and location for resuming the course.
         * @param {String} scoId
         * @returns {Boolean} true or false
         */
        canResume: learningData.canResume,


        // core api

        /**
         * @private
         */
        getSequenceData: learningData.getSequenceData,

        /**
         * @private
         */
        setSequenceData: learningData.setSequenceData,

        /**
         * @private
         * @deprecated
         */
        getMasteryScore: learningData.getMasteryScore,

        /**
         * @private
         */
        getLessonLocation: learningData.getLessonLocation,

        /**
         * @private
         */
        setUsername: learningData.setUsername,

        /**
         * @private
         */
        getUsername: function () {

            let userName = learningData.getUsername();
            if( userName ) {
                return userName;
            }

            userName = dataAdapter.getUsername();
            learningData.setUsername(userName);
            return userName;
        },

        refreshDataBuffer: function (mapSequenceIds) {
            let sequenceId,
                data;

            for( sequenceId in mapSequenceIds ) {
                if( mapSequenceIds.hasOwnProperty(sequenceId) ) {
                    data = {
                        score: dataAdapter.getScore(sequenceId),
                        lessonStatus: dataAdapter.getStatus(sequenceId),
                        lessonLocation: dataAdapter.getLocation(sequenceId)
                    };
                    learningData.setLearningData(sequenceId, data);
                }
            }

            Event.trigger( document, CourseEvents.BUFFER_REFRESHED );
        }
    };
}
